module.exports = __webpack_public_path__ + "static/img/contact_bg.7e1ff5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact_bg.png
// module id = 339b
// module chunks = 0